export default __webpack_public_path__ + "static/media/config-hris2.feab07dc.svg";